import React from 'react'
import secondarySponsorStyles from '../../styles/tracker-modules/secondarySponsor.module.less'

const SecondarySponsor = ({ urls }) => {
  const alt = "logo of this page's sponsor"
  let imgs = []
  if (urls.includes(",")) {
  	imgs = urls.split(",")
  } else {
  	imgs.push(urls)
  }

  return (
    <section className={secondarySponsorStyles.wrapper}>
      <p className={secondarySponsorStyles.hed}>Supported by</p>
      <div className={secondarySponsorStyles.logoContainer}>
      	{imgs.map((img) => (
		      <img className={secondarySponsorStyles.logo} alt={alt} src={img} />
      	))}
    	</div>
    </section>
  )
}

export default SecondarySponsor